import { render, staticRenderFns } from "./WorkspacesSidebar.vue?vue&type=template&id=b118d00e&"
import script from "./WorkspacesSidebar.vue?vue&type=script&lang=ts&"
export * from "./WorkspacesSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspacesSidebar.vue?vue&type=style&index=0&id=b118d00e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports